import { View, Text, Switch, TouchableOpacity, StyleSheet } from 'react-native';
import { useState } from 'react';
import {
  requestNotificationPermission,
  scheduleWorkoutReminder,
  cancelWorkoutReminder,
  saveNotificationPrefs,
} from '@/hooks/useNotifications';

interface Props {
  studentId: string;
  initialEnabled: boolean;
  initialHour: number;
}

const HOURS = [6, 7, 8, 9, 10, 12, 14, 16, 17, 18, 19, 20, 21];

export function NotificationSettings({ studentId, initialEnabled, initialHour }: Props) {
  const [enabled, setEnabled] = useState(initialEnabled);
  const [hour, setHour] = useState(initialHour);
  const [saving, setSaving] = useState(false);

  async function handleToggle(value: boolean) {
    if (value) {
      const granted = await requestNotificationPermission();
      if (!granted) return;
    }
    setSaving(true);
    setEnabled(value);
    if (value) {
      await scheduleWorkoutReminder(hour);
    } else {
      await cancelWorkoutReminder();
    }
    await saveNotificationPrefs(studentId, value, hour);
    setSaving(false);
  }

  async function handleHourChange(h: number) {
    setHour(h);
    if (enabled) {
      await scheduleWorkoutReminder(h);
      await saveNotificationPrefs(studentId, enabled, h);
    }
  }

  return (
    <View style={styles.card}>
      <View style={styles.row}>
        <Text style={styles.title}>Lembrete de treino</Text>
        <Switch
          value={enabled}
          onValueChange={handleToggle}
          trackColor={{ false: '#ddd', true: '#C8102E' }}
          thumbColor="#fff"
          disabled={saving}
          accessibilityRole="switch"
        />
      </View>
      {enabled && (
        <View style={styles.hourRow}>
          {HOURS.map(h => (
            <TouchableOpacity
              key={h}
              style={[styles.hourChip, hour === h && styles.hourChipActive]}
              onPress={() => handleHourChange(h)}
            >
              <Text style={[styles.hourText, hour === h && styles.hourTextActive]}>
                {String(h).padStart(2, '0')}h
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  card: { backgroundColor: '#fff', borderRadius: 12, padding: 14, borderWidth: 1.5, borderColor: '#eee', marginBottom: 10 },
  row: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  title: { fontSize: 14, fontWeight: '600', color: '#1A1A1A' },
  hourRow: { flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 10 },
  hourChip: { paddingHorizontal: 10, paddingVertical: 6, borderRadius: 8, borderWidth: 1, borderColor: '#eee', backgroundColor: '#fafafa' },
  hourChipActive: { backgroundColor: '#C8102E', borderColor: '#C8102E' },
  hourText: { fontSize: 12, color: '#555' },
  hourTextActive: { color: '#fff', fontWeight: '600' },
});
